function setupErrorMessages() {
  const form = document.getElementById('pre-checkout-form')
  const inputs = form.querySelectorAll('[aria-required="true"]')

  inputs.forEach(input => {
    const errorDiv = document.createElement('small')
    errorDiv.className = 'contact__field-error hidden'
    errorDiv.id = `${input.id}-error`
    errorDiv.innerHTML = `
      <span class="visually-hidden">Error</span>
      <span class="form__message">
        This field is required
      </span>
    `

    let container = input.closest('.field') || input.closest('.field-checkbox')
    if (!container) {
      container = input.parentElement.parentElement
    }
    container.appendChild(errorDiv)
  })
}

setupErrorMessages()

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

function isValidPhone(phone) {
  const phoneRegex = /^[\d\s\-\+\(\)]+$/.test(phone) && phone.replace(/\D/g, '').length >= 7
  return phoneRegex
}

function getErrorMessage(input) {
  const type = input.type
  const value = input.value.trim()
  const inputType = input.getAttribute('data-type')

  if (!value) {
    return 'This field is required'
  }

  if (inputType === 'email' || type === 'email') {
    return !isValidEmail(value) ? 'Please enter a valid email address' : null
  }

  if (inputType === 'phone' || type === 'tel') {
    return !isValidPhone(value) ? 'Please enter a valid phone number' : null
  }

  return null
}

function isElementHidden(el) {
  while (el && el !== document.body) {
    if (el.style.display === 'none') return true
    if (el.classList && el.classList.contains('hidden')) return true
    el = el.parentElement
  }
  return false
}

function validateFormInputs(form) {
  const requiredInputs = form.querySelectorAll('[aria-required="true"]')
  let isValid = true
  let firstInvalidInput = null

  requiredInputs.forEach(input => {
    if (isElementHidden(input)) return

    if (input.id === 'terms_accepted' && input.disabled) {
      const errorEl = document.getElementById('terms_accepted-error')
      input.setAttribute('aria-invalid', true)
      if (errorEl) {
        errorEl.classList.remove('hidden')
        const messageSpan = errorEl.querySelector('.form__message')
        if (messageSpan) messageSpan.textContent = 'Please open and read the Terms & Conditions first'
      }
      isValid = false
      if (!firstInvalidInput) firstInvalidInput = input
      return
    }

    let isInvalid = false
    let errorMessage = 'This field is required'

    if (input.type === 'checkbox') {
      isInvalid = !input.checked
    } else {
      const value = input.value.trim()
      isInvalid = !value

      if (!isInvalid) {
        const customError = getErrorMessage(input)
        if (customError) {
          isInvalid = true
          errorMessage = customError
        }
      }
    }

    const errorEl = document.getElementById(`${input.id}-error`)

    input.setAttribute('aria-invalid', isInvalid)

    if (isInvalid) {
      input.style.borderColor = '#dc2626'
      input.classList.add('error')
    } else {
      input.style.borderColor = ''
      input.classList.remove('error')
    }

    if (errorEl) {
      errorEl.classList.toggle('hidden', !isInvalid)
      if (isInvalid) {
        const messageSpan = errorEl.querySelector('.form__message')
        if (messageSpan) {
          messageSpan.textContent = errorMessage
        }
      }
    }

    if (isInvalid) {
      isValid = false
      if (!firstInvalidInput) firstInvalidInput = input
    }
  })

  return { isValid, firstInvalidInput }
}


document.getElementById('eligibility-form').addEventListener('submit', (e) => {
  e.preventDefault()

  const { isValid, firstInvalidInput } = validateFormInputs(e.target)

  if (!isValid) {
    firstInvalidInput.focus()
    return
  }

  document.getElementById('eligibility-form').classList.add('hidden')
  const preCheckoutForm = document.getElementById('pre-checkout-form')
  preCheckoutForm.classList.remove('hidden')
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

document.getElementById('pre-checkout-form').addEventListener('submit', async (e) => {
  e.preventDefault()

  const { isValid, firstInvalidInput } = validateFormInputs(e.target)

  if (!isValid) {
    firstInvalidInput.focus()
    return
  }

  const data = {}

  document.getElementById('eligibility-form').querySelectorAll('input, select').forEach(el => {
    if (el.name) data[el.name] = el.value
  })

  e.target.querySelectorAll('input, select').forEach(el => {
    if (el.name) data[el.name] = el.value
  })

  await sendPreCheckoutMetaObject(data)
})

async function sendPreCheckoutMetaObject(data, eligibleOverride = null) {
  let isEligible
  if (eligibleOverride !== null) {
    isEligible = eligibleOverride
  } else {
    const ineligibleSection = document.getElementById('ineligible-section')
    isEligible = ineligibleSection && ineligibleSection.style.display !== 'none' ? 'no' : 'yes'
  }

  let appliedVetCode = data['has-vet-code'] === 'no' ? 'COLISHIELD26' : ''
  if (data['has-vet-code'] === 'yes') {
    try {
      const cartRes = await fetch('/cart.js')
      const cart = await cartRes.json()
      if (cart.discount_codes && cart.discount_codes.length > 0) {
        appliedVetCode = cart.discount_codes[0].code
      }
    } catch (err) {
      console.error('[pre-checkout] Failed to fetch cart:', err)
    }
  }

  // Save each field as a flat key/value pair before the network call
  const flatData = {
    is_eligible:           isEligible,
    has_vet_code:          data['has-vet-code'] || '',
    vet_code:              appliedVetCode,
    horse_age_valid:       data['horse-age-valid'] || '',
    current_health_status: data['current-health-status'] || '',
    no_ongoing_treatment:  data['no-ongoing-treatment'] || '',
    no_major_illnesses:    data['no-major-illnesses'] || '',
    no_current_medications:data['no-current-medications'] || '',
    colic_assessment_needed: data['colic-assessment-needed'] || '',
    colic_number:          data['colic_number'] || '',
    colic_last_date:       data['colic_last_name'] || '',
    colic_vet_call:        data['colic_vet_call'] || '',
    colic_treatment:       data['colic_treatment'] || '',
    location_compatible:   data['location-compatible'] || '',
    intended_usage_allowed:data['intended-usage-allowed'] || '',
    customer_name:         data['customer_name'] || '',
    customer_email:        data['customer_email'] || '',
    customer_phone:        data['customer_phone'] || '',
    customer_address:      data['customer_address'] || '',
    stable_name:           data['stable_name'] || '',
    passport_name:         data['passport_name'] || '',
    year_of_birth:         data['year_of_birth'] || '',
    microchip_number:      data['microchip_number'] || '',
    passport_number:       data['passport_number'] || '',
    horse_use:             data['horse_use'] || '',
    vet_name:              data['vet_name'] || '',
    practice_name:         data['practice_name'] || '',
    practice_phone:        data['practice_phone'] || '',
    practice_email:        data['practice_email'] || '',
  }
  localStorage.setItem('pre_checkout_data', JSON.stringify(flatData))
  localStorage.setItem('pre_checkout_completed', '1')

  if (data['has-vet-code'] === 'no') {
    window.location.href = '/discount/COLISHIELD26?redirect=/cart'
  } else {
    window.location.href = '/cart'
  }
}


function setVisible(id, visible) {
  const el = document.getElementById(id)
  if (el) el.style.display = visible ? '' : 'none'
}

function collectFormData(formId) {
  const data = {}
  document.getElementById(formId).querySelectorAll('input, select').forEach(el => {
    if (el.name) data[el.name] = el.value
  })
  return data
}

function clearFields(id) {
  const el = document.getElementById(id)
  if (el) el.querySelectorAll('input, select').forEach(f => { f.value = '' })
}

function setColicFormVisible(visible) {
  const form = document.getElementById('colic-form')
  if (!form) return
  const wasVisible = !form.classList.contains('hidden')
  if (wasVisible && !visible) {
    form.querySelectorAll('input, select').forEach(f => { f.value = '' })
  }
  form.classList.toggle('hidden', !visible)
  form.querySelectorAll('[aria-required]').forEach(f =>
    f.setAttribute('aria-required', String(visible))
  )
}

function checkEligibility() {
  if (!document.getElementById('eligibility-form')) return

  const steps = [
    { containerId: 'h2-age-health'            },
    { containerId: 'q-horse-age-valid',       selectId: 'horse-age-valid'        },
    { containerId: 'q-current-health-status', selectId: 'current-health-status'  },
    { containerId: 'q-no-ongoing-treatment',  selectId: 'no-ongoing-treatment'   },
    { containerId: 'h2-medical-history'       },
    { containerId: 'q-no-major-illnesses',    selectId: 'no-major-illnesses'     },
    { containerId: 'medical-q2',              selectId: 'no-current-medications' },
    { containerId: 'medical-q3',              selectId: 'colic-assessment-needed', type: 'colic' },
    { containerId: 'h2-location-usage'        },
    { containerId: 'q-location-compatible',   selectId: 'location-compatible'    },
    { containerId: 'location-q2',             selectId: 'intended-usage-allowed' },
  ]

  const triggeredIndex = steps.findIndex(({ selectId, type }) => {
    if (!selectId) return false
    const el = document.getElementById(selectId)
    if (!el || el.value === '') return false
    return type === 'colic'
      ? el.value === 'yes'
      : el.value === el.getAttribute('data-ineligible-value')
  })

  steps.forEach(({ containerId }, i) => {
    const hide = triggeredIndex !== -1 && i > triggeredIndex
    const el = document.getElementById(containerId)
    if (hide && el && el.style.display !== 'none') clearFields(containerId)
    setVisible(containerId, !hide)
  })

  const isTriggered = triggeredIndex !== -1
  const isColic = isTriggered && steps[triggeredIndex].type === 'colic'

  setColicFormVisible(isColic)
  setVisible('colic-review-message', isColic)
  setVisible('medical-ineligible-section', isTriggered)
  setVisible('eligibility-next-btn', !isTriggered)

  if (isTriggered) {
    const btn = document.getElementById('medical-ineligible-proceed')
    if (btn) btn.dataset.eligibleValue = isColic ? 'pending' : 'no'
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const eligibilityForm = document.getElementById('eligibility-form')
  if (eligibilityForm) {
    eligibilityForm.addEventListener('change', checkEligibility)
    checkEligibility()
    console.log('Eligibility form listener configured')
  } else {
    console.error('eligibility-form not found')
  }

  const tcLink = document.getElementById('tc-link')
  if (tcLink) {
    tcLink.addEventListener('click', () => {
      const checkbox = document.getElementById('terms_accepted')
      const hint = document.getElementById('tc-link-hint')
      if (checkbox) {
        checkbox.disabled = false
        checkbox.style.borderColor = ''
        checkbox.setAttribute('aria-invalid', false)
        const errorEl = document.getElementById('terms_accepted-error')
        if (errorEl) errorEl.classList.add('hidden')
      }
      if (hint) hint.style.display = 'none'
    })
  }
})

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkEligibility)
} else {
  checkEligibility()
}

function proceedWithValidation(eligibleValue) {
  const form = document.getElementById('eligibility-form')
  const { isValid, firstInvalidInput } = validateFormInputs(form)
  if (!isValid) {
    firstInvalidInput.focus()
    return
  }
  sendPreCheckoutMetaObject(collectFormData('eligibility-form'), eligibleValue)
}

document.getElementById('medical-ineligible-proceed').addEventListener('click', () => {
  const btn = document.getElementById('medical-ineligible-proceed')
  proceedWithValidation(btn.dataset.eligibleValue || 'no')
})

